export default __webpack_public_path__ + "static/4-9b90db03ae80159d851b3629eb5b72de.png";